module.exports = __webpack_public_path__ + "static/media/Christine_Baker.244cd14b.jpg";